
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("27fbe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $6mKj3 = parcelRequire("6mKj3");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $80d639dd0f6e39b4$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $80d639dd0f6e39b4$export$df09efd65c0d0dfa = new class WidgetConnectorExperienceTrackerSupport {
    isTrackable(extension) {
        return Boolean(extension?.url);
    }
    start(extension) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.WIDGET_CONNECTOR_EMBED_EXPERIENCE),
            attributes: {
                hostLabel: extension?.hostLabel
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.WIDGET_CONNECTOR_EMBED_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.WIDGET_CONNECTOR_EMBED_EXPERIENCE),
            error: $80d639dd0f6e39b4$var$getError(messageOrError)
        });
    }
    abort(reason) {
        (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.WIDGET_CONNECTOR_EMBED_EXPERIENCE),
            reason: reason
        });
    }
}();





const $89c87c1684e283d9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    urlNotSpecified: {
        id: "widget-macro.error.url-not-specified",
        defaultMessage: "No URL specified."
    },
    myspaceOutdated: {
        id: "widget-macro.error.myspace-outdated",
        defaultMessage: "This myspace URL is outdated, please update."
    },
    flashDeprecated: {
        id: "widget-macro.error.flash-deprecated",
        defaultMessage: "This widget cannot be displayed because it requires Adobe Flash, which is no longer supported by modern browsers."
    },
    unsupportedProvider: {
        id: "widget-macro.error.unsupported-provider",
        defaultMessage: "The widget at {url} cannot be embedded."
    },
    macroLabel: {
        id: "widget-macro.label",
        defaultMessage: "Widget Connector"
    },
    macroDescription: {
        id: "widget-macro.desc",
        defaultMessage: "Embed YouTube videos, Flickr slideshows, Twitter streams, Google Docs and other content from the web."
    },
    embedTitle: {
        id: "widget-macro.embed-title",
        defaultMessage: "Embedded {provider} content"
    },
    twitterWidgetHeading: {
        id: "widget-macro.twitter.widget.heading",
        defaultMessage: "Loading Twitter Widget"
    },
    twitterWidgetMessage: {
        id: "widget-macro.twitter.widget.message",
        defaultMessage: "Widget #{widgetId}"
    },
    twitterWidgetLink: {
        id: "widget-macro.twitter.widget.link",
        defaultMessage: "Loading Widget #{widgetId}"
    },
    twitterSingleError: {
        id: "widget-macro.twitter.single.error",
        defaultMessage: "Error rendering Tweet {tweetId}\u2026"
    }
});












var $1VhsF = parcelRequire("1VhsF");


const $8197b5fa11d333cb$export$fddf379e22a74b00 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro-no-url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).urlNotSpecified)));
};















const $38d6d7a6e3cabdb8$export$25d42260c532cac5 = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (descriptor.hostLabel === 'myspace-outdated') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro-deprecated-myspace"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).myspaceOutdated)));
    // Default: flash-deprecated providers (DailyMotion, Flickr, Tudou)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro-deprecated"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).flashDeprecated)));
};


/* ErrorEmbed.tsx generated by @compiled/babel-plugin v3.0.2 */ 












const $2012743203197547$var$styles = {
    root: "_3iDTPbvbI6"
};
const $2012743203197547$export$bfa2ec7d8c9e7d12 = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2012743203197547$var$styles.root,
        testId: "widget-macro-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).unsupportedProvider, {
        url: descriptor.hostLabel ?? descriptor.embedUrl
    })));
};


/* FullscreenIframeEmbed.tsx generated by @compiled/babel-plugin v3.0.2 */ 









const $6335317aa1bcb368$var$styles = {
    root: "_30huDKYbGa _43nrzT8HPE _0rIjyk8HPE"
};
const $6335317aa1bcb368$export$81851bfdf816c7ee = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).embedTitle, {
        provider: descriptor.provider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6335317aa1bcb368$var$styles.root,
        testId: "widget-macro-fullscreen-iframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: title,
        src: descriptor.embedUrl,
        width: descriptor.width || undefined,
        height: descriptor.height || undefined,
        frameBorder: 0,
        allowTransparency: true,
        allowFullScreen: true
    }));
};


/* IframeEmbed.tsx generated by @compiled/babel-plugin v3.0.2 */ 









const $a8ace42245d3b984$var$styles = {
    root: "_30huDKYbGa _43nrzT8HPE _0rIjyk8HPE"
};
const $a8ace42245d3b984$export$b831f091f9cedb10 = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).embedTitle, {
        provider: descriptor.provider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a8ace42245d3b984$var$styles.root,
        testId: "widget-macro-iframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: title,
        src: descriptor.embedUrl,
        width: descriptor.width || undefined,
        height: descriptor.height || undefined,
        frameBorder: 0,
        allowTransparency: true
    }));
};









var $7vK9E = parcelRequire("7vK9E");





var $4aRua = parcelRequire("4aRua");


const $fc56463c72659320$export$199e33f6d46f4ffe = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (descriptor.widgetId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro-twitter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).twitterWidgetHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).twitterWidgetMessage, {
        widgetId: descriptor.widgetId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: descriptor.embedUrl,
        rel: "noopener noreferrer",
        target: "_blank",
        "aria-label": formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).twitterWidgetLink, {
            widgetId: descriptor.widgetId
        })
    }, descriptor.embedUrl));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro-twitter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: descriptor.embedUrl,
        rel: "noopener noreferrer",
        target: "_blank"
    }, descriptor.embedUrl));
};


/* YoutubeIframeEmbed.tsx generated by @compiled/babel-plugin v3.0.2 */ 









const $c554c8279d0fe1fd$var$styles = {
    root: "_2V7sgOdnbC _3hxITiYbGa"
};
const $c554c8279d0fe1fd$export$e0d8783c71d432ea = ({ descriptor: descriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $89c87c1684e283d9$export$a7357cdd1f0b0168).embedTitle, {
        provider: descriptor.provider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c554c8279d0fe1fd$var$styles.root,
        testId: "widget-macro-youtube-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: title,
        "data-testid": "widget-macro-youtube-iframe",
        src: descriptor.embedUrl,
        width: descriptor.width || undefined,
        height: descriptor.height || undefined,
        frameBorder: 0,
        allowTransparency: true
    }));
};


/**
 * Shared, SSR-safe helpers used by the per-provider matchers.
 *
 * Mirrors the behaviour of the legacy `WidgetConnectorUtil` java helper.
 */ const $dfac4d1b72358c3e$var$BASE_URL_PATTERN = /^https?:\/\/([^/]+)(?:\/.*)?$/;
const $dfac4d1b72358c3e$export$892cb1c023073ddf = [
    'jira-dev.com',
    'atl-pass.net',
    'atlassian.net'
];
function $dfac4d1b72358c3e$export$6268306c4a1a8f2a(url) {
    const match = $dfac4d1b72358c3e$var$BASE_URL_PATTERN.exec(url);
    return match ? match[1] : url;
}
function $dfac4d1b72358c3e$export$94fb57df311bd629(url) {
    return $dfac4d1b72358c3e$export$892cb1c023073ddf.some((domain)=>url.includes(domain));
}
function $dfac4d1b72358c3e$export$223fed989275a9e5(url, expectedHost, expectedPathContains) {
    try {
        const parsed = new URL(url);
        return parsed.host === expectedHost && (parsed.pathname || '').includes(expectedPathContains);
    } catch  {
        return false;
    }
}
function $dfac4d1b72358c3e$export$b7abaee8a7e8f274(url, matchUrl) {
    try {
        const host = new URL(url).host;
        return Boolean(host) && url.includes(matchUrl);
    } catch  {
        return false;
    }
}
function $dfac4d1b72358c3e$export$2c1332e1eec6676c(value, unit = 'px') {
    if (value === undefined || value === '') return undefined;
    return /^\d+$/.test(value) ? `${value}${unit}` : value;
}


const $1a9ef0e5662c3c78$var$MATCH_URL = 'dailymotion.com';
const $1a9ef0e5662c3c78$var$PATTERN = /^https?:\/\/(www\.)?dailymotion\.com\/.+/;
const $1a9ef0e5662c3c78$export$b253a74794a9d212 = (url)=>{
    if (!(0, $dfac4d1b72358c3e$export$b7abaee8a7e8f274)(url, $1a9ef0e5662c3c78$var$MATCH_URL) || !$1a9ef0e5662c3c78$var$PATTERN.test(url)) return null;
    // Legacy embed used Flash. Modern browsers can no longer render it.
    return {
        kind: 'deprecated',
        provider: 'DailyMotion',
        embedUrl: url.replace('/video/', '/swf/video/'),
        width: '',
        height: '',
        hostLabel: 'flash-deprecated'
    };
};



const $70711465ed25e674$var$PATTERN = /^https:\/\/www\.figma\.com\/.*/;
const $70711465ed25e674$var$DEFAULT_WIDTH = '800px';
const $70711465ed25e674$var$DEFAULT_HEIGHT = '450px';
const $70711465ed25e674$export$77d216be35193a56 = (url, params)=>{
    if (!$70711465ed25e674$var$PATTERN.test(url)) return null;
    const embedUrl = `${url.replace('www', 'embed')}&embed-host=confluence-cloud`;
    return {
        kind: 'iframe',
        provider: 'Figma',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $70711465ed25e674$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $70711465ed25e674$var$DEFAULT_HEIGHT
    };
};


const $f4a734df297f032a$var$MATCH_URL = 'flickr.com';
const $f4a734df297f032a$export$545bb3d15ca4a438 = (url)=>{
    if (!url.includes($f4a734df297f032a$var$MATCH_URL)) return null;
    // Legacy renderer relied on (a) Flash and (b) screen-scraping flickr.com to resolve
    // user ids server-side. Both are unsupported in the React renderer.
    return {
        kind: 'deprecated',
        provider: 'Flickr',
        embedUrl: url,
        width: '',
        height: '',
        hostLabel: 'flash-deprecated'
    };
};



const $fcf636542c24968b$var$HOST = 'www.google.com';
const $fcf636542c24968b$var$PATH = '/calendar';
const $fcf636542c24968b$var$DEFAULT_WIDTH = '800px';
const $fcf636542c24968b$var$DEFAULT_HEIGHT = '600px';
const $fcf636542c24968b$export$df25ddcebebbaf32 = (url, params)=>{
    if (!(0, $dfac4d1b72358c3e$export$223fed989275a9e5)(url, $fcf636542c24968b$var$HOST, $fcf636542c24968b$var$PATH)) return null;
    return {
        kind: 'iframe',
        provider: 'Google Calendar',
        embedUrl: url,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $fcf636542c24968b$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $fcf636542c24968b$var$DEFAULT_HEIGHT
    };
};



const $e6366ea77c0913e9$var$MATCH_URL = 'docs.google.com';
const $e6366ea77c0913e9$var$DOCUMENT_PATTERN = /(document)\/d\/([^/]+)&?/;
const $e6366ea77c0913e9$var$PRESENTATION_PATTERN = /(presentation)\/d\/([^/]+)&?/;
const $e6366ea77c0913e9$var$EMBED_BASE = '//docs.google.com/';
const $e6366ea77c0913e9$var$DEFAULT_WIDTH = '768px';
const $e6366ea77c0913e9$var$DEFAULT_HEIGHT = '342px';
const $e6366ea77c0913e9$export$7a2c6b1088f4e916 = (url, params)=>{
    if (!url.includes($e6366ea77c0913e9$var$MATCH_URL)) return null;
    let embedUrl = null;
    for (const pattern of [
        $e6366ea77c0913e9$var$DOCUMENT_PATTERN,
        $e6366ea77c0913e9$var$PRESENTATION_PATTERN
    ]){
        const match = pattern.exec(url);
        if (match) {
            const docType = match[1];
            const docId = match[2];
            embedUrl = `${$e6366ea77c0913e9$var$EMBED_BASE}${docType}/d/${docId}`;
            if (docType === 'presentation') embedUrl += '/embed';
            else if (docType === 'document') embedUrl += '/pub?embedded=true';
            break;
        }
    }
    if (!embedUrl) return null;
    return {
        kind: 'iframe',
        provider: 'Google Docs',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $e6366ea77c0913e9$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $e6366ea77c0913e9$var$DEFAULT_HEIGHT
    };
};



const $b2fe9662d5f7ba06$var$MATCH_URL = 'maps.google.com';
const $b2fe9662d5f7ba06$var$PATTERN = /^https?:\/\/maps\.google\.com\/.+/;
const $b2fe9662d5f7ba06$var$DEFAULT_WIDTH = '425px';
const $b2fe9662d5f7ba06$var$DEFAULT_HEIGHT = '350px';
const $b2fe9662d5f7ba06$export$f6b898edbd85743b = (url, params)=>{
    if (!(0, $dfac4d1b72358c3e$export$b7abaee8a7e8f274)(url, $b2fe9662d5f7ba06$var$MATCH_URL) || !$b2fe9662d5f7ba06$var$PATTERN.test(url)) return null;
    return {
        kind: 'iframe',
        provider: 'Google Maps',
        embedUrl: `${url}&output=embed`,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $b2fe9662d5f7ba06$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $b2fe9662d5f7ba06$var$DEFAULT_HEIGHT
    };
};



const $5e28eef8a95586c9$var$KEY_PATTERN = /key=([^&]+)/;
const $5e28eef8a95586c9$var$DEFAULT_WIDTH = '720px';
const $5e28eef8a95586c9$var$DEFAULT_HEIGHT = '360px';
const $5e28eef8a95586c9$var$matchOldSpreadsheetUrl = (url)=>{
    const match = $5e28eef8a95586c9$var$KEY_PATTERN.exec(url);
    if (!match) return null;
    return `//docs.google.com/spreadsheet/pub?key=${match[1]}&output=html&widget=true&element=true&gid=0`;
};
const $5e28eef8a95586c9$var$matchNewSpreadsheetUrl = (url)=>{
    if (!url.endsWith('/pubhtml')) return null;
    return `${url}?widget=true&headers=false&chrome=false`;
};
const $5e28eef8a95586c9$export$4e1680c644ea62b = (url, params)=>{
    if (!(0, $dfac4d1b72358c3e$export$223fed989275a9e5)(url, 'spreadsheets.google.com', '') && !(0, $dfac4d1b72358c3e$export$223fed989275a9e5)(url, 'docs.google.com', '/spreadsheet')) return null;
    const embedUrl = $5e28eef8a95586c9$var$matchOldSpreadsheetUrl(url) ?? $5e28eef8a95586c9$var$matchNewSpreadsheetUrl(url);
    if (!embedUrl) return null;
    return {
        kind: 'iframe',
        provider: 'Google Sheets',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $5e28eef8a95586c9$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $5e28eef8a95586c9$var$DEFAULT_HEIGHT
    };
};



const $4a645c0210e88cda$var$PATTERN = /https?:\/\/(.+\.)?web\.microsoftstream\.com\/(?:embed\/)?video\/([a-zA-Z0-9-]+)/;
const $4a645c0210e88cda$var$PATTERN_EMBED = /https?:\/\/(.+\.)?web\.microsoftstream\.com\/embed\/video\/([a-zA-Z0-9-]+)/;
const $4a645c0210e88cda$var$DEFAULT_WIDTH = '640px';
const $4a645c0210e88cda$var$DEFAULT_HEIGHT = '360px';
const $4a645c0210e88cda$export$2767f8953b1b1b6a = (url, params)=>{
    if (!$4a645c0210e88cda$var$PATTERN.test(url)) return null;
    const embedUrl = $4a645c0210e88cda$var$PATTERN_EMBED.test(url) ? url : `${url.replace('/video/', '/embed/video/')}?autoplay=false&showinfo=true`;
    return {
        kind: 'iframe',
        provider: 'Microsoft Stream',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $4a645c0210e88cda$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $4a645c0210e88cda$var$DEFAULT_HEIGHT
    };
};



const $73322966df143664$var$OLD_MATCH_PATTERN = /https?:\/\/vids\.myspace\.com.*$/i;
const $73322966df143664$var$MATCH_PATTERN = /https?:\/\/(www\.)?myspace\.com.*$/i;
const $73322966df143664$var$EMBED_PATTERN = /https?:\/\/(www\.)?myspace\.com(\/.+)?\/video\/(.+?)(\/.+)?\/(\d+)/i;
const $73322966df143664$var$buildEmbedUrl = (url)=>{
    const match = $73322966df143664$var$EMBED_PATTERN.exec(url);
    let videoName = '';
    let videoId = '';
    if (match) {
        videoName = match[4] ?? '';
        if (!videoName) videoName = `/${match[3] ?? ''}`;
        videoId = match[5] ?? '';
        if (videoName.length > 0 && !videoName.endsWith('-')) videoName = `${videoName}-`;
    }
    return `//myspace.com/play/video${videoName}${videoId}`;
};
const $73322966df143664$export$985f0f9b64f44756 = (url, params)=>{
    if ($73322966df143664$var$OLD_MATCH_PATTERN.test(url)) return {
        kind: 'deprecated',
        provider: 'MySpace',
        embedUrl: url,
        width: '',
        height: '',
        hostLabel: 'myspace-outdated'
    };
    if (!$73322966df143664$var$MATCH_PATTERN.test(url)) return null;
    let normalisedUrl = url;
    if (normalisedUrl.startsWith('/')) normalisedUrl = `https://myspace.com${normalisedUrl}`;
    return {
        kind: 'iframe',
        provider: 'MySpace',
        embedUrl: $73322966df143664$var$buildEmbedUrl(normalisedUrl),
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? '',
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? ''
    };
};



const $95167d8c318eb8c0$var$MATCH_URL = 'scribd.com';
const $95167d8c318eb8c0$var$PATTERN = /^https?:\/\/(www\.)?scribd\.com\/(doc|document|read)\/(\d+)\/.+/;
const $95167d8c318eb8c0$var$DEFAULT_WIDTH = '475px';
const $95167d8c318eb8c0$var$DEFAULT_HEIGHT = '355px';
const $95167d8c318eb8c0$export$8e3968d0d5b2038c = (url, params)=>{
    if (!url.includes($95167d8c318eb8c0$var$MATCH_URL)) return null;
    const match = $95167d8c318eb8c0$var$PATTERN.exec(url);
    if (!match) return null;
    const docId = match[3];
    // The legacy renderer screen-scraped scribd.com to retrieve an `access_key` server-side.
    // We cannot perform that lookup safely in the browser, so we fall back to the public
    // no-access-key embed URL which works for publicly shared documents.
    return {
        kind: 'iframe',
        provider: 'Scribd',
        embedUrl: `//www.scribd.com/embeds/${docId}/content?start_page=1&view_mode=scroll&show_recommendations=false`,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $95167d8c318eb8c0$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $95167d8c318eb8c0$var$DEFAULT_HEIGHT
    };
};


const $fc69779611af0d7c$var$MATCH_URL = 'tudou';
const $fc69779611af0d7c$var$VIDEO_ID_PATTERN = /v\/([^/]+)/;
const $fc69779611af0d7c$export$dc50251177ca3a7d = (url)=>{
    if (!url.includes($fc69779611af0d7c$var$MATCH_URL)) return null;
    const idMatch = $fc69779611af0d7c$var$VIDEO_ID_PATTERN.exec(url);
    const videoId = idMatch ? idMatch[1] : '';
    return {
        kind: 'deprecated',
        provider: 'Tudou',
        embedUrl: `//tudou.com/v/${videoId}&hl=en&fs=1`,
        width: '',
        height: '',
        hostLabel: 'flash-deprecated'
    };
};



const $65ff2d1da53cd809$var$SINGLE_TWEET_PATTERN = /^https?:\/\/twitter\.com\/(.*?)\/status(es)?\/(\d+)+(\/(.)*)?(\?(.)*)?/;
const $65ff2d1da53cd809$var$WIDGET_PATTERN = /https?:\/\/twitter\.com\/settings\/widgets\/(\d+).*$/;
const $65ff2d1da53cd809$export$a97896fd703eb4c2 = (url, params)=>{
    const widgetMatch = $65ff2d1da53cd809$var$WIDGET_PATTERN.exec(url);
    if (widgetMatch) return {
        kind: 'twitter-widget',
        provider: 'Twitter',
        embedUrl: url,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? '',
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? '',
        widgetId: widgetMatch[1]
    };
    if ($65ff2d1da53cd809$var$SINGLE_TWEET_PATTERN.test(url)) return {
        kind: 'twitter-widget',
        provider: 'Twitter',
        embedUrl: url,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? '',
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? ''
    };
    return null;
};



const $5a7028d9f5af5345$var$DEFAULT_WIDTH = '400px';
const $5a7028d9f5af5345$var$DEFAULT_HEIGHT = '300px';
const $5a7028d9f5af5345$var$MATCH_URL = 'vimeo.com';
const $5a7028d9f5af5345$var$EMBED_URL = 'https://player.vimeo.com/video/';
// Regular Vimeo URLs (with optional unlisted-video hash in the path).
// Capture groups: 1 = videoId, 3 = hash (optional)
const $5a7028d9f5af5345$var$REGULAR_WITH_HASH = /\/(\d+)(\/(\w+))\/?($|\?|#)/;
// Embed URLs use ?h=<hash> instead of /<hash>/
// Capture groups: 1 = videoId, 3 = hash
const $5a7028d9f5af5345$var$EMBEDDED_WITH_HASH = /\/(\d+)\/?\?(h=(\w+))/;
const $5a7028d9f5af5345$var$VIDEO_ID_PATTERN = /\/(\d+)/;
const $5a7028d9f5af5345$export$7a3397e8edbf00df = (url, params)=>{
    if (!url.includes($5a7028d9f5af5345$var$MATCH_URL)) return null;
    let embedUrl = $5a7028d9f5af5345$var$EMBED_URL;
    const regularMatch = $5a7028d9f5af5345$var$REGULAR_WITH_HASH.exec(url);
    const embeddedMatch = $5a7028d9f5af5345$var$EMBEDDED_WITH_HASH.exec(url);
    const matched = regularMatch ?? embeddedMatch;
    if (matched && matched[1]) {
        embedUrl = `${$5a7028d9f5af5345$var$EMBED_URL}${matched[1]}`;
        const hash = matched[3];
        if (hash) embedUrl += `?h=${hash}`;
    } else {
        const idMatch = $5a7028d9f5af5345$var$VIDEO_ID_PATTERN.exec(url);
        if (idMatch && idMatch[1]) embedUrl = `${$5a7028d9f5af5345$var$EMBED_URL}${idMatch[1]}`;
    }
    return {
        kind: 'fullscreen-iframe',
        provider: 'Vimeo',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $5a7028d9f5af5345$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $5a7028d9f5af5345$var$DEFAULT_HEIGHT
    };
};



const $e4c7e9f0d94604d6$var$MATCH_URL = 'wufoo.com';
const $e4c7e9f0d94604d6$var$PATTERN = /http:\/\/([^.]+)\.wufoo\.com\/([^/]+)\/([^/]+)/;
const $e4c7e9f0d94604d6$var$DEFAULT_WIDTH = '100%';
const $e4c7e9f0d94604d6$var$DEFAULT_HEIGHT = '500px';
const $e4c7e9f0d94604d6$export$eac929fba374382e = (url, params)=>{
    if (!url.includes($e4c7e9f0d94604d6$var$MATCH_URL)) return null;
    const match = $e4c7e9f0d94604d6$var$PATTERN.exec(url);
    if (!match) return null;
    const userId = match[1];
    const type = match[2];
    const id = match[3];
    const embedUrl = type === 'reports' ? `//${userId}.wufoo.com/reports/${id}/` : `//${userId}.wufoo.com/embed/${id}/`;
    return {
        kind: 'iframe',
        provider: 'Wufoo',
        embedUrl: embedUrl,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $e4c7e9f0d94604d6$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $e4c7e9f0d94604d6$var$DEFAULT_HEIGHT
    };
};



const $b3ff5909e895124c$var$YOUTUBE_URL_PATTERN = /https?:\/\/(.+\.)?youtube\.com.*(\?v=([^&]+)).*$/;
const $b3ff5909e895124c$var$DEFAULT_WIDTH = '400px';
const $b3ff5909e895124c$var$DEFAULT_HEIGHT = '300px';
const $b3ff5909e895124c$var$stripPlayerEmbeddedFlag = (url)=>url.includes('feature=player_embedded&') ? url.replace('feature=player_embedded&', '') : url;
const $b3ff5909e895124c$export$1f15cb726e754144 = (url, params)=>{
    const sanitised = $b3ff5909e895124c$var$stripPlayerEmbeddedFlag(url);
    const match = $b3ff5909e895124c$var$YOUTUBE_URL_PATTERN.exec(sanitised);
    if (!match) return null;
    const videoId = match[3];
    return {
        kind: 'youtube-iframe',
        provider: 'YouTube',
        embedUrl: `//www.youtube.com/embed/${videoId}?wmode=opaque`,
        width: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.width) ?? $b3ff5909e895124c$var$DEFAULT_WIDTH,
        height: (0, $dfac4d1b72358c3e$export$2c1332e1eec6676c)(params.height) ?? $b3ff5909e895124c$var$DEFAULT_HEIGHT
    };
};



/**
 * Provider matchers in dispatch priority order. Mirrors the registration order
 * of `WidgetRenderer` beans in the legacy `atlassian-plugin.xml` so that for any
 * URL the same provider that historically claimed it continues to do so.
 */ const $5cba7cb7426053dc$var$PROVIDER_MATCHERS = [
    (0, $b3ff5909e895124c$export$1f15cb726e754144),
    (0, $5a7028d9f5af5345$export$7a3397e8edbf00df),
    (0, $1a9ef0e5662c3c78$export$b253a74794a9d212),
    (0, $4a645c0210e88cda$export$2767f8953b1b1b6a),
    (0, $73322966df143664$export$985f0f9b64f44756),
    (0, $fc69779611af0d7c$export$dc50251177ca3a7d),
    (0, $f4a734df297f032a$export$545bb3d15ca4a438),
    (0, $70711465ed25e674$export$77d216be35193a56),
    (0, $e6366ea77c0913e9$export$7a2c6b1088f4e916),
    (0, $5e28eef8a95586c9$export$4e1680c644ea62b),
    (0, $fcf636542c24968b$export$df25ddcebebbaf32),
    (0, $b2fe9662d5f7ba06$export$f6b898edbd85743b),
    (0, $95167d8c318eb8c0$export$8e3968d0d5b2038c),
    (0, $e4c7e9f0d94604d6$export$eac929fba374382e),
    (0, $65ff2d1da53cd809$export$a97896fd703eb4c2)
];
function $5cba7cb7426053dc$export$88ed893553f7cfef(url, params) {
    const host = (0, $dfac4d1b72358c3e$export$6268306c4a1a8f2a)(url);
    if ((0, $dfac4d1b72358c3e$export$94fb57df311bd629)(url)) return {
        kind: 'error',
        provider: 'unknown',
        embedUrl: url,
        width: '',
        height: '',
        hostLabel: host
    };
    for (const matcher of $5cba7cb7426053dc$var$PROVIDER_MATCHERS){
        const result = matcher(url, params);
        if (result && result.embedUrl) return result;
    }
    return {
        kind: 'error',
        provider: 'unknown',
        embedUrl: url,
        width: '',
        height: '',
        hostLabel: host
    };
}
function $5cba7cb7426053dc$export$c4b33762fb8f2965(input) {
    return {
        width: input.width?.value || undefined,
        height: input.height?.value || undefined
    };
}
const $5cba7cb7426053dc$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $89c87c1684e283d9$export$a7357cdd1f0b0168).unsupportedProvider,
        values: {
            url: ''
        }
    });
/**
 * Stateless presentation component that renders the appropriate DOM for the
 * supplied `EmbedDescriptor`. Each `kind` is handled by a dedicated subcomponent
 * in `./components/embeds/`. This component is SSR-safe (no `window`/`document`
 * access at module scope and no effects required for the iframe variants).
 */ const $5cba7cb7426053dc$var$EmbedView = ({ descriptor: descriptor })=>{
    switch(descriptor.kind){
        case 'iframe':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8ace42245d3b984$export$b831f091f9cedb10), {
                descriptor: descriptor
            });
        case 'fullscreen-iframe':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6335317aa1bcb368$export$81851bfdf816c7ee), {
                descriptor: descriptor
            });
        case 'youtube-iframe':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c554c8279d0fe1fd$export$e0d8783c71d432ea), {
                descriptor: descriptor
            });
        case 'twitter-widget':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc56463c72659320$export$199e33f6d46f4ffe), {
                descriptor: descriptor
            });
        case 'deprecated':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38d6d7a6e3cabdb8$export$25d42260c532cac5), {
                descriptor: descriptor
            });
        case 'error':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2012743203197547$export$bfa2ec7d8c9e7d12), {
                descriptor: descriptor
            });
    }
};
/**
 * Tracks the WIDGET_CONNECTOR_EMBED_EXPERIENCE for the "Widget connector embed"
 * capability (Group 6 of the @ecosystem Feature Test Migration), gated behind the
 * `confluence_enable_connect_group_6_metrics` experiment.
 *
 * Unlike Connect iframes, widget embeds resolve synchronously — the outcome is
 * known as soon as the URL is dispatched to a provider matcher — so the
 * experience starts and resolves within a single effect. Renders nothing; mirrors
 * the canonical singleton-backed pattern with start/succeed/fail + guard refs.
 */ const $5cba7cb7426053dc$var$WidgetConnectorEmbedExperience = ({ rawUrl: rawUrl, hostLabel: hostLabel, descriptorError: descriptorError })=>{
    const experienceStartedRef = (0, $cozmU.useRef)(false);
    const experienceResolvedRef = (0, $cozmU.useRef)(false);
    // Note: this component is only rendered when the
    // `confluence_enable_connect_group_6_metrics` flag is on (gated at the call
    // site in WidgetMacroRendererInner), so no flag check is needed here.
    const startExperienceIfNeeded = (0, $cozmU.useCallback)(()=>{
        const extension = {
            url: rawUrl,
            hostLabel: hostLabel
        };
        if (!(0, $80d639dd0f6e39b4$export$df09efd65c0d0dfa).isTrackable(extension)) return false;
        if (!experienceStartedRef.current) {
            (0, $80d639dd0f6e39b4$export$df09efd65c0d0dfa).start(extension);
            experienceStartedRef.current = true;
        }
        return true;
    }, [
        rawUrl,
        hostLabel
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!startExperienceIfNeeded() || experienceResolvedRef.current) return;
        if (descriptorError) (0, $80d639dd0f6e39b4$export$df09efd65c0d0dfa).fail(descriptorError);
        else (0, $80d639dd0f6e39b4$export$df09efd65c0d0dfa).succeed();
        experienceResolvedRef.current = true;
    }, [
        startExperienceIfNeeded,
        descriptorError
    ]);
    // Abort if the component unmounts before the render experience resolves.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (experienceStartedRef.current && !experienceResolvedRef.current) (0, $80d639dd0f6e39b4$export$df09efd65c0d0dfa).abort('WidgetMacroRenderer unmounted before widget embed experience resolved');
        };
    }, []);
    return null;
};
const $5cba7cb7426053dc$var$WidgetMacroRendererInner = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, macroBody: macroBody })=>{
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const macroId = macroDefaultProps?.attributes?.macroId;
    const rawUrl = macroParams?.url?.value?.trim() || macroBody?.trim() || '';
    if (!rawUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8197b5fa11d333cb$export$fddf379e22a74b00), null));
    const sanitised = $5cba7cb7426053dc$export$c4b33762fb8f2965({
        width: macroParams?.width,
        height: macroParams?.height
    });
    const descriptor = $5cba7cb7426053dc$export$88ed893553f7cfef(rawUrl, sanitised);
    const descriptorError = descriptor.kind === 'error' ? new Error(`Unsupported widget provider for ${descriptor.hostLabel || rawUrl}`) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, descriptorError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: descriptorError
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), (0, $6mKj3.expVal)('confluence_enable_connect_group_6_metrics', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cba7cb7426053dc$var$WidgetConnectorEmbedExperience, {
        rawUrl: rawUrl,
        hostLabel: descriptor.hostLabel,
        descriptorError: descriptorError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "widget-macro",
        "data-fabric-macro": macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cba7cb7426053dc$var$EmbedView, {
        descriptor: descriptor
    })));
};
const $5cba7cb7426053dc$export$964b2f5d85861200 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $5cba7cb7426053dc$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cba7cb7426053dc$var$WidgetMacroRendererInner, props));
module.exports["dispatchEmbed"] = $5cba7cb7426053dc$export$88ed893553f7cfef;
module.exports["sanitiseParams"] = $5cba7cb7426053dc$export$c4b33762fb8f2965;
module.exports["WidgetMacroRenderer"] = $5cba7cb7426053dc$export$964b2f5d85861200;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});


//# sourceMappingURL=WidgetMacroRenderer.f7048a23.js.map
